import { handleResponse } from '@/services/handleresponse'

// const API_URL = 'https://api.irmastore.id/'
// const API_URL = 'http://localhost:8081/'
 const API_URL = 'https://api.irmastore.id/'

export const IRMACapitalService = {
    getContracts,
    getRePayments,
    createContract,
    doRequestCapital,
    getLoan,
    doRepayment,
    getSettings,
    getRequestCapitaldata
}

function getSettings () {

    return fetch(API_URL + 'irmacapital/setting', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getRePayments (opt) {
    console.log(opt)

    var sort="id"
    var sorder="DESC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    return fetch(API_URL + 'irmacapital/loan/payment?awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getContracts (opt) {
    var sort="id"
    var sorder="DESC"
    if(opt.sortBy){
        console.log(opt.sortBy)
    }
    if(opt.sortDesc){
        if(opt.sortDesc[0]){
            sorder="DESC"
        }
    }
    if(opt.itemsPerPage<0){
        opt.itemsPerPage=10000
    }
    let page=opt.page-1;
    let sorting=sort+","+sorder
    return fetch(API_URL + 'irmacapital/loan/contract?awal='+opt.awal+"&akhir="+opt.akhir+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function createContract (postdata) {
    return fetch(API_URL + 'irmacapital/loan/contract', {
        method: 'POST',
        body: JSON.stringify({ postdata }.postdata),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function doRepayment (postdata) {
    return fetch(API_URL + 'irmacapital/loan/payment', {
        method: 'POST',
        body: JSON.stringify({ postdata }.postdata),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function doRequestCapital (postdata) {
    return fetch(API_URL + 'irmacapital/loan/request', {
        method: 'POST',
        body: JSON.stringify({ postdata }.postdata),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getRequestCapitaldata () {
    return fetch(API_URL + 'irmacapital/loan/request', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}

function getLoan () {
    return fetch(API_URL + 'irmacapital/loan', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
